<script>
import CampanhaIcone from "@/components/marketing/components/CampanhaIcone"
import MRadio from "@/components/marketing/components/inputs/Radio"
import MCheckbox from "@/components/marketing/components/inputs/Checkbox"
import NavBar from "@/components/marketing/components/NavBar"
import Vue from "vue"
import Destinatarios from "@/components/marketing/Etapas/Destinatarios"
import Configuracao from "@/components/marketing/Etapas/Configuracao"

Vue.component('destinatarios', Destinatarios)
Vue.component('configuracao', Configuracao)

export default {
  name: 'MarketingCriarCampanha2',
  inject: {
    erplayout: {
      default() {
        console.error('Main needs to be child of ErpLayout')
      }
    }
  },
  directives: {},
  components: {NavBar, MCheckbox, MRadio, CampanhaIcone},
  data() {
    return {
      component: 'destinatarios',
    }
  },
  watch: {
    '$route'(r) {
      this.component = r.params.action
    }
  },
  computed: {},
  mounted() {
    this.erplayout.erpheader.menu.setActiveMenu('marketing')
    window.setTimeout(() => {
      this.erplayout.erpheader.setMenuModuleToggle(true)
    }, 400)
  },
  destroyed() {
    // document.querySelector('.u-erp-layout-container').classList.remove('bg-white')
  },
  methods: {},
  meta: {
    title: 'Criar Campanha - Marketing',
    name: 'Criar Campanha - Marketing'
  }
}
</script>

<template>
  <div class="mkt-module">
    <component v-bind:is="component"/>
    <nav-bar @changeComponent="(c) => component = c.id" :step="component"/>
  </div>
</template>

